module.exports = __webpack_public_path__ + "img/icon1.e158dee3.png";